import React from "react";

const EmptyState = () => (
    <img
        src={require('#app/assets/frames/income-list.svg')}
        alt=""
        style={{ width: '100%' }}
    />
);

export default EmptyState